import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconVodafoneTvProps } from './IconVodafoneTv.types'
import * as Styled from './styles/IconVodafoneTv.style'

import { nonThemeableRules } from '../../ruleSet'

const IconVodafoneTv: FC<IconVodafoneTvProps> = ({
  size = nonThemeableRules.defaultSize as number as IconVodafoneTvProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconVodafoneTvProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path d='m19.68 15.531-1.008-.937-1.004.937m2.012 2.133-1.008.938-1.004-.938' vectorEffect='non-scaling-stroke' />
          <path
            d='M16.977 11.543H21.5v8.055a1.84 1.84 0 0 1-1.836 1.84h-1.98a1.84 1.84 0 0 1-1.84-1.84v-6.926a1.14 1.14 0 0 1 1.125-1.125Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M15.844 19.031H7.25c-1.52 0-2.75-1.23-2.75-2.75V7.72c0-1.52 1.23-2.75 2.75-2.75h8.46c1.52 0 2.75 1.23 2.75 2.75v3.824'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M13.465 12c0 1.098-.89 1.984-1.985 1.984A1.986 1.986 0 1 1 13.465 12Zm0 0' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconVodafoneTv
